import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Cookies } from 'react-cookie-consent';
import StaticTypeWriter from "./StatictTypeWritingEffect/StaticTypeWriter";
import StaticFooter from "./StaticFooter";
import { staticHeader } from "../../Services/CommonServices/helper";
import ReactPlayer from "react-player";
import parse from 'html-react-parser';
import axios from "axios";

function DynamicComponent(props) {
    const navigate = useNavigate();
    const allowedUrls = Cookies.get('acceptedPaths') ? Cookies.get('acceptedPaths') : [];
    const [data, setData] = useState()
    const location = useLocation();
    const pathName = location.pathname.split('/')[1]
    const [isTitle, setIsTitle] = useState(false);
    const [isDescription, setIsDescription] = useState(false);
    const [activeGender, setActiveGender] = useState("men");
    const [contentFadeIn, setContentFadeIn] = useState(false);
    const [isToggleBtnVisible, setIsToggleBtnVisible] = useState(false);
    const [downArrow, setShowDownArrow] = useState(false);
    const languagePreferred = useMemo(() => Cookies?.get('locale') || "en", []);

    useEffect(() => {
        if(!allowedUrls.includes(pathName)) {
            navigate('*')
        } else {
            const bucketUrl = Cookies.get('bucketUrl') || props.bucketUrl;
            const cardFolder = Cookies.get('cardFolder') || props.cardFolder;
            axios.get(`${bucketUrl}assets/apac/${languagePreferred}/Dynamic_Pages/${cardFolder}/${pathName}.json`).then(response => {
                if(response.data) {
                setData(response.data);
                fetchData(activeGender);
                } else {
                    navigate('*')
                }
            })
            .catch(error => {
                navigate('*')
                setData([]);
                console.error("Error fetching JSON:", error)
            });
        }
    }, []);
    
    useEffect(() => {  
        if(data && data.title)
            staticHeader(data?.title, "titleHeader");
        if(data && data.description)
            staticHeader(data?.description, "subHeaderContainer");
      }, [isTitle]);

    useEffect(() => {
        const toggleFlag = document.getElementById("toggle-btn");
        if(data?.options === false || toggleFlag) {
            setIsToggleBtnVisible(true);
        }
    }, [isDescription]);
    
    const fetchData = (gender) => {
        setActiveGender(gender);
        setContentFadeIn(true);
        setTimeout(() => {
            setContentFadeIn(false);
        }, 500);
    }

    const handleClick = (url) => {
        if(url){
            window.open(url, "_blank", "noopener,noreferrer");
        } 
    }

    const onProductClick = (product_url) => {
        if(product_url){
            window.open(product_url, "_blank", "noopener,noreferrer");
        }
    };

    // scroll to bottom arrow functionality
    useEffect(() => {
        const pageContainer = document.getElementById('styleGuidePageContainer');
        if (!pageContainer) return;

        let initialViewportHeight = pageContainer.clientHeight;
        const handleScroll = () => {
            const overflownspace = pageContainer.scrollHeight - pageContainer.scrollTop - pageContainer.clientHeight;      
            if (overflownspace > initialViewportHeight * 0.1) {        
                setShowDownArrow(true);
            } else {
                setShowDownArrow(false);
            }
            return;
        };

        const observer = new MutationObserver(() => {
            setTimeout(handleScroll, 100);
        });
        observer.observe(pageContainer, { childList: true, subtree: true });
        pageContainer.addEventListener('scroll', handleScroll);
        handleScroll();
        setTimeout(handleScroll, 300);
        return () => {
            pageContainer.removeEventListener('scroll', handleScroll);
            setShowDownArrow(false);
            observer.disconnect();
        }
    }, [data, isToggleBtnVisible, activeGender]);

    const scrollToEnd = () => {
        const pageContainer = document.getElementById('styleGuidePageContainer');
        if (pageContainer) {
            pageContainer.scrollTo({
                top: pageContainer.scrollHeight - 100,
                behavior: 'smooth'
            });
            setShowDownArrow(false);
        }
    };

    const adjustDownArrowPosition = () => {
        const downArrowElement = document.querySelector('.down-arrow');

        if (downArrowElement) {
            downArrowElement.style.bottom = '15px';
            downArrowElement.style.left = '50%';
            downArrowElement.style.transform = 'translateX(-50%)';
        }
    };

    useEffect(() => {
        adjustDownArrowPosition();
        
        const handleResize = () => {
            adjustDownArrowPosition();
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [downArrow]);

    return (
        <div
        >
            { data && 
                <div
                className="container p-0 art-of-bundling-up bigfive overflow"
                style={{ backgroundColor: "#EFEFEF" }}
                   id="styleGuidePageContainer"
              >
                
            <div>
                <img style={{ width: "100%" }} src={data?.headerImage} alt="top" />
            </div>
            <div className="content card align-items-center">
                { data?.title && 
                    <div className="title" id="titleHeader">
                        <div style={{ display: "none" }}>
                            <StaticTypeWriter text={data?.title} setLoading={setIsTitle} />
                        </div>
                    </div>
                }
                {!data?.title || isTitle && (
                    <div className="subheader" id="subHeaderContainer">
                        <div style={{ display: "none" }}>
                            <StaticTypeWriter
                            text={data?.description}
                            setLoading={setIsDescription}
                            />
                        </div>
                    </div>
                )}
                {
                    isDescription && data?.options &&
                        <div id="toggle-btn" className="toggle-container">
                            <div
                                className={`toggle-background ${activeGender === "women" ? "toggle-bg-women" : ""}`}
                                style={{
                                transform: activeGender === "men" ? "translateX(0)" : "translateX(100%)",
                                }}
                            ></div>
                            <button 
                                className={`toggle-btn men-btn ${activeGender === "men" ? "active" : ""}`}
                                onClick={() => fetchData("men")}
                            >
                                Men
                            </button>
                            <button 
                                className={`toggle-btn ${activeGender === "women" ? "active women-btn" : ""}`}
                                onClick={() => fetchData("women")}
                            >
                                Women
                            </button>
                        </div>
                }
                {isToggleBtnVisible &&
                    <div>
                        { data.options === true ? (
                            <div className={`${contentFadeIn ? "seaside-static-delay" : ""}`}>
                                {data?.products && data?.products?.map((product, index) => (
                                    <div key={`product-${index}-${product.id || index}`} className={`staticProductTypeWriter`}>
                                        { product.gender === activeGender &&
                                            <div className={"staticProductCard"+index}>
                                                <div className="staticProductCard">
                                                    <section id={"art"+index}>
                                                        { product.lifestyleImage && 
                                                            <div className="row d-flex mx-0 mt-0 p-0 row-gap brandimg_spacing">
                                                                <img className="p-0"
                                                                    src={product.lifestyleImage}
                                                                    alt="product-img"
                                                                    height="100%"
                                                                    width="100%"
                                                                />
                                                            </div>
                                                        }
                                                        {product.id &&
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <div className="n-text">
                                                                    {product.id}
                                                                </div>
                                                            </div>
                                                        }
                                                        {product.sectionTitle &&
                                                            <div className="product-header">
                                                                {product.sectionTitle}
                                                            </div>
                                                        }
                                                        {
                                                            product.sectionDescriptions &&
                                                                <div className="product-copy">
                                                                    {parse(product.sectionDescriptions)}
                                                                </div>
                                                        }
                                                        <div>
                                                            <div className="d-grid product-grid">
                                                                { product.product_url &&
                                                                    <div>
                                                                        <div className="utility-button" style={{ marginBottom: product.quotes ? "40px": "20px",marginTop: "0px" }}>
                                                                            <button
                                                                            name="shopButton"
                                                                            onClick={() => handleClick(product.product_url)}
                                                                            className="utility_btn d-flex align-items-center justify-content-center"
                                                                            >
                                                                                <img
                                                                                src="/static/assets/shop-icon.svg"
                                                                                alt="shop_icon"
                                                                                width="13px"
                                                                                height="13.46px"
                                                                                />
                                                                                <span className="utility-text">Shop</span>
                                                                            </button>
                                                                        </div> 
                                                                        {product.quotes && 
                                                                            <div className="product-quotes">
                                                                                {product.quotes}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                }                     
                                                                <div className="d-grid">
                                                                    <div className="row d-flex m-0 row-gap">
                                                                        { product?.media?.map((media, index) => (
                                                                            <React.Fragment key={`media-${index}-${media.url || index}`}>
                                                                                { media.type === "image" ? 
                                                                                    <div className={`col-6 col-md-4 ps-0 pe p-md-1" ${media.product_url !== "" && 'cursor-pointer'}`}>
                                                                                        <img
                                                                                        src={media.url}
                                                                                        alt="product-img"
                                                                                        height="100%"
                                                                                        width="100%"
                                                                                        className={`p-0 ${media.product_url && 'product-image'}`}
                                                                                        onClick={() => onProductClick(media.product_url)}
                                                                                        />
                                                                                    </div>
                                                                                    :
                                                                                    <>
                                                                                        <div className="d-grid p-0">
                                                                                            <div className="row d-flex m-0 row-gap">
                                                                                            <ReactPlayer
                                                                                                className="polo-product-img px-0 mb-0"
                                                                                                url={media.url}
                                                                                                playing={false}
                                                                                                loop
                                                                                                width="100%"
                                                                                                height="auto"
                                                                                                controls
                                                                                            />
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                { product.landscapeUrl && 
                                                                    <div className="row m-0 col-12" style={{ paddingTop: "2px" }}>
                                                                        <img
                                                                            src={product.landscapeUrl}
                                                                            className="p-0"
                                                                            alt="img"
                                                                            height="100%"
                                                                            width="100%"
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        }
                                </div>
                                ))}
                            </div>
                        ) : (
                            <div className={`${contentFadeIn ? "seaside-static-delay" : ""}`}>
                                {data?.products && data?.products?.map((product, index) => (
                                    <div key={`product-else-${index}-${product.id || index}`} className={`staticProductTypeWriter`}>
                                        <div className={"staticProductCard"+index}>
                                            <div className="staticProductCard">
                                                <section id={"art"+index}>
                                                    { product.lifestyleImage && 
                                                        <div className="row d-flex mx-0 mt-0 p-0 row-gap brandimg_spacing">
                                                            <img className="p-0"
                                                                src={product.lifestyleImage}
                                                                alt="product-img"
                                                                height="100%"
                                                                width="100%"
                                                            />
                                                        </div>
                                                    }
                                                    {product.id &&
                                                        <div className="d-flex align-items-center justify-content-center">
                                                            <div className="n-text">
                                                                {product.id}
                                                            </div>
                                                        </div>
                                                    }
                                                    {product.sectionTitle &&
                                                        <div className="product-header">
                                                            {product.sectionTitle}
                                                        </div>
                                                    }
                                                    {
                                                        product.sectionDescriptions &&
                                                            <div className="product-copy">
                                                                {parse(product.sectionDescriptions)}
                                                            </div>
                                                    }
                                                    <div>
                                                        <div className="d-grid product-grid">
                                                            { product.product_url &&
                                                                <div>
                                                                    <div className="utility-button" style={{ marginBottom: product.quotes ? "40px": "20px",marginTop: "0px" }}>
                                                                        <button
                                                                        name="shopButton"
                                                                        onClick={() => handleClick(product.product_url)}
                                                                        className="utility_btn d-flex align-items-center justify-content-center"
                                                                        >
                                                                            <img
                                                                            src="/static/assets/shop-icon.svg"
                                                                            alt="shop_icon"
                                                                            width="13px"
                                                                            height="13.46px"
                                                                            />
                                                                            <span className="utility-text">Shop</span>
                                                                        </button>
                                                                    </div> 
                                                                    {product.quotes && 
                                                                        <div className="product-quotes">
                                                                            {product.quotes}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }                     
                                                            <div className="d-grid">
                                                                <div className="row d-flex m-0 row-gap">
                                                                    { product?.media?.map((media, index) => (
                                                                        <React.Fragment key={`media-else-${index}-${media.url || index}`}>
                                                                            { media.type === "image" ? 
                                                                                <div className={`col-6 col-md-4 ps-0 pe p-md-1" ${media.product_url !== "" && 'cursor-pointer'}`}>
                                                                                    <img
                                                                                    src={media.url}
                                                                                    alt="product-img"
                                                                                    height="100%"
                                                                                    width="100%"
                                                                                    className={`p-0 ${media.product_url && 'product-image'}`}
                                                                                    onClick={() => onProductClick(media.product_url)}
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <>
                                                                                    <div className="d-grid p-0">
                                                                                        <div className="row d-flex m-0 row-gap">
                                                                                        <ReactPlayer
                                                                                            className="polo-product-img px-0 mb-0"
                                                                                            url={media.url}
                                                                                            playing={false}
                                                                                            loop
                                                                                            width="100%"
                                                                                            height="auto"
                                                                                            controls
                                                                                        />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </React.Fragment>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            { product.landscapeUrl && 
                                                                <div className="row m-0 col-12" style={{ paddingTop: "2px" }}>
                                                                    <img
                                                                        src={product.landscapeUrl}
                                                                        className="p-0"
                                                                        alt="img"
                                                                        height="100%"
                                                                        width="100%"
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                </div>
                                ))}
                            </div>
                        )}
                    </div>
                }
            </div>
            {isToggleBtnVisible && (
                <StaticFooter />
            )}

            {downArrow && (
                <button
                    className="down-arrow"
                    onClick={scrollToEnd}
                    style={{ 
                        position: 'fixed',
                        bottom: '44px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1001,
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <img
                        alt="down-arrow"
                        src="./static/assets/scrollDown.svg"
                    />
                </button>
            )}
            </div>
            }
        </div>
    );
}

export default DynamicComponent;